// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__8r1ll","title":"AfterFrontImage_title__1vE_W"};